import { inject, Injectable } from '@angular/core';
import { API_BASE_URL } from '@environment/environment';
import { HttpService } from '@services/http/http.service';
import { AjaxResponse } from '@models/types/ajax-response.type';
import { AuthService } from '@services/auth/auth.service';



@Injectable({
  providedIn: 'root'
})
export class SettingsService {

private readonly httpSvc: HttpService = inject(HttpService);
readonly authSvc: AuthService = inject(AuthService);
private getUserData = this.authSvc.getAuthData();
constructor() { }

  async getUserPin(seq: any) {
    let req;
    if(this.getUserData?.seq){
      req = this.getUserData?.seq;
    }else{
      req = seq;
    }
    const url = API_BASE_URL + 'usersettings/getuserpin/' + req;
    const response = await this.httpSvc.get<AjaxResponse<{
      userPin: string;
    }>>([url], true);
    return response.data;
  }
  
  async saveUser(params: any): Promise<any[]> {
    const url = API_BASE_URL + 'usersettings/saveuser/'+ this.getUserData?.seq;
    const response = await this.httpSvc.post<AjaxResponse<any[]>>([url, params], true);
    return response.data;
  }

}
